package com.essntl.features.service.ui.allservice

import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.domain.model.service.ServiceModel

sealed interface AllServiceEvent {
    data object GetAllCategory : AllServiceEvent
    data object Refresh : AllServiceEvent
    data class SelectCategory(val categoryId: String?) : AllServiceEvent
    data class GetAllService(val organizationId: String? = null) : AllServiceEvent
    data object LoadMoreServices : AllServiceEvent
    data class DeleteService(val service: ServiceModel) : AllServiceEvent
    data class SelectService(val id: String?) : AllServiceEvent
    data class EditFilterOptions(val filterOptions: ServiceFilterOptions) : AllServiceEvent
}